export const TOAST_MESSAGES = {
  welcome: '환영합니다!',
  addMileage: {
    succeed: '마일리지를 추가했습니다!',
    failed: '마일리지 추가에 실패했습니다. 다시 시도해주세요',
  },
  editMileage: {
    succeed: '마일리지를 수정했습니다!',
    failed: '마일리지 수정에 실패했습니다. 다시 시도해주세요',
  },
  deleteMileage: {
    succeed: '마일리지를 삭제했습니다!',
    failed: '마일리지 삭제에 실패했습니다. 다시 시도해주세요',
  },
  requiredField: '필수 정보를 입력해 주세요.',
  checkConsent: '개인 정보 수집을 동의해주세요!',
  failedAuth: '로그인 후 사용할 수 있습니다.',
  default: '알 수 없는 오류가 발생했어요. 다시 시도해 주세요.',
};
